import { createFileRoute, redirect } from '@tanstack/react-router'
import { MainLayout } from '../components/MainLayout'
import { DividendsPage } from '../pages/DividendsPage'
import { useAuthStore } from '../stores/auth-store'

export const Route = createFileRoute('/dividends' as any)({
    // Wrapped in MainLayout like every other authenticated page. Without it
    // the page renders with no sidebar and no user menu -- reachable only by
    // typing the URL, and with no way back out.
    component: () => (
        <MainLayout>
            <DividendsPage />
        </MainLayout>
    ),
    beforeLoad: () => {
        const { isAuthenticated } = useAuthStore.getState()
        if (!isAuthenticated) {
            throw redirect({ to: '/login' })
        }
    },
})
